
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { FeaturedServices } from './components/FeaturedServices';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Gallery } from './components/Gallery';
import { ServiceArea } from './components/ServiceArea';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';
import { SEOStructuredData } from '../../components/SEOStructuredData';

export default function HomePage() {
  return (
    <>
      <SEOStructuredData />
      <header>
        <Navbar />
      </header>
      <main>
        <Hero />
        <About />
        <Services />
        <FeaturedServices />
        <WhyChooseUs />
        <Gallery />
        <ServiceArea />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
